import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'ct-extraction-table-overlay-row-remove-container',
  imports: [],
  templateUrl: './table-overlay-row-remove-container.component.html',
  styles: [
    `
      :host {
        @apply h-full w-full;
      }
    `,
  ],
})
export class TableOverlayRowRemoveContainerComponent {
  @Output() buttonClicked = new EventEmitter<void>();
  @Input({ required: true }) isIgnored = false;
}
